module.exports = __webpack_public_path__ + "images/8d766588a4f12731f6711ba26c20dde8-illu_ruler.svg";